// extracted by mini-css-extract-plugin
export default {"tip":"RestoreFromSafeButton__tip--1q0bA","tipContent":"RestoreFromSafeButton__tipContent--3IiV9","tipText":"RestoreFromSafeButton__tipText--2rXd7"};